import {rasterTileLayer} from '../../endpoints';
import rasterStyleFactory from './rasterStylesFactory';

const LAYER_NAMES = {
    BASIC_MAIN: 'tomtomRasterBasicMain',
    HYBRID_MAIN: 'tomtomRasterHybridMain',
    LABELS_MAIN: 'tomtomRasterLabelsMain',
    BASIC_NIGHT: 'tomtomRasterBasicNight',
    HYBRID_NIGHT: 'tomtomRasterHybridNight',
    LABELS_NIGHT: 'tomtomRasterLabelsNight'
};

const BASIC_MAIN = () => rasterStyleFactory('map-basic-main', LAYER_NAMES.BASIC_MAIN, rasterTileLayer,
    {'{layer}': 'basic', '{style}': 'main', '{tileSize}': 512 });
const HYBRID_MAIN = () => rasterStyleFactory('map-hybrid-main', LAYER_NAMES.HYBRID_MAIN, rasterTileLayer,
    {'{layer}': 'hybrid', '{style}': 'main', '{tileSize}': 512 });
const LABELS_MAIN = (isSymbol) => rasterStyleFactory('map-labels-main', LAYER_NAMES.LABELS_MAIN, rasterTileLayer,
    {'{layer}': 'labels', '{style}': 'main', '{tileSize}': 512 }, isSymbol ? 'symbolLayer' : '');

const BASIC_NIGHT = () => rasterStyleFactory('map-basic-night', LAYER_NAMES.BASIC_NIGHT, rasterTileLayer,
    {'{layer}': 'basic', '{style}': 'night', '{tileSize}': 512 });
const HYBRID_NIGHT = () => rasterStyleFactory('map-hybrid-night', LAYER_NAMES.HYBRID_NIGHT, rasterTileLayer,
    {'{layer}': 'hybrid', '{style}': 'night', '{tileSize}': 512 });
const LABELS_NIGHT = () => rasterStyleFactory('map-labels-night', LAYER_NAMES.LABELS_NIGHT, rasterTileLayer,
    {'{layer}': 'labels', '{style}': 'night', '{tileSize}': 512 });

const STYLES = {
    BASIC_MAIN,
    HYBRID_MAIN,
    LABELS_MAIN,
    BASIC_NIGHT,
    HYBRID_NIGHT,
    LABELS_NIGHT
};

export default function(layer, style, isSymbol) {
    return STYLES[`${layer.toUpperCase()}_${style.toUpperCase()}`](isSymbol);
}



// WEBPACK FOOTER //
// ./map/tier/styleParts/rasterMap.js